module.exports = __webpack_public_path__ + "lato-semibold-c2b50f4a7d908c8d06f5b05ec135e166.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-semibold/lato-semibold.woff
// module id = 1055
// module chunks = 0